export default __webpack_public_path__ + "static/media/Groundnut.7dae2646.png";